import { render, staticRenderFns } from "./RelatedResourceTag.vue?vue&type=template&id=78929b11&"
import script from "./RelatedResourceTag.vue?vue&type=script&lang=js&"
export * from "./RelatedResourceTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports